import config from 'react-global-configuration';

if (process.env.NODE_ENV === 'production') {
    config.set(window.Config);
} else {
    config.set({
        version: "v3-38",
        urlbaseMock: "https://11b858dc-b736-4a1c-9a4b-75ab28686df2.mock.pstmn.io",
        urlbase: process.env.REACT_APP_API_URL_BASE,
        apiKey: process.env.REACT_APP_API_KEY,
        s3: {
            accessKeyId: 'AKIAWDNJIEJKS7IRP5XV',
            secretAccessKey: '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',
            region: 'us-east-1',
            bucketFiles: 'esgscan-imovel-files-dev',
            bucketKML: 'esgscan-imovel-kml-dev'
        },
        apiKeyGm: process.env.REACT_APP_API_GOOGLE,
        cognito: {
            //  Amazon Cognito User Pool ID
            userPoolId: process.env.REACT_APP_USER_POOL_ID,
            // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
            userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENTID,
            // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
            identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
            // OPTIONAL - This is used when autoSignIn is enabled for Auth.signUp
            // 'code' is used for Auth.confirmSignUp, 'link' is used for email link verification
            signUpVerificationMethod: process.env.REACT_APP_SIGN_UP_VERIFICATION_METHOD, // 'code' | 'link'
            loginWith: {
                // OPTIONAL - Hosted UI configuration
                oauth: {}
            }
        }
    });
}